namespace HA.Core.Repository {

    export class User extends Repository {

        public getUserProfile(data: Map<string, any>) {
            return this.request(toMap({
                url: "/user/profile",
                data: [],
            }));
        }

        /**
         *
         * @param data
         * @returns {any}
         */
        public findByCredencial(data: Map<string, any>) {
            return this.request(toMap({
                url: "/user/login",
                data,
            }));
        }

        public getUser() {
            return new HA.Core.Entity.User({pic: "/media/img/richo", name: "Richo", id: "AXCVFG"});
        }
    }
}
